var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFinishBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icono / Outlined / Solicitud Resuelta") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.4053,18 C11.1413,18 10.8863,17.896 10.6983,17.707 L7.6983,14.707 C7.3073,14.315 7.3073,13.684 7.6983,13.293 C8.0893,12.901 8.7213,12.901 9.1123,13.293 L11.1883,15.369 L15.1333,8.502 C15.4063,8.021 16.0163,7.857 16.4983,8.133 C16.9763,8.408 17.1423,9.02 16.8673,9.498 L12.2723,17.498 C12.1173,17.768 11.8453,17.95 11.5373,17.991 C11.4933,17.997 11.4493,18 11.4053,18 Z M13.5,5.5 C13.5,6.328 12.829,7 12,7 C11.171,7 10.5,6.328 10.5,5.5 C10.5,4.672 11.171,4 12,4 C12.829,4 13.5,4.672 13.5,5.5 Z M19,21 L19,5 L14.52,5 L14.248,4.431 C13.827,3.548 12.965,3 12,3 C11.035,3 10.173,3.548 9.752,4.431 L9.48,5 L5,5 L5,21 L19,21 Z M19,3 C20.103,3 21,3.897 21,5 L21,21 C21,22.103 20.103,23 19,23 L5,23 C3.897,23 3,22.103 3,21 L3,5 C3,3.897 3.897,3 5,3 L8.272,3 C9.1,1.768 10.502,1 12,1 C13.498,1 14.9,1.768 15.728,3 L19,3 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icono-/-Outlined-/-Solicitud-Resuelta",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#000000",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u2731-/-Color-/-Black-/-800",
    mask: "url(#mask-2)",
    fill: "#444444"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-13",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinishBlack);
export default __webpack_public_path__ + "static/media/finish-black.4976802201945c3eb73cfd8967bfae45.svg";
export { ForwardRef as ReactComponent };